/*
 * File: user-role.ts
 * Created: 2025-12-08 19:02:19
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2025-12-08 19:05:26
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { BaseComponent } from "@root/components";

@Component
export default class UserRole extends BaseComponent {
    // 取得角色列表 (確保回傳陣列)
    get roles(): string[] {
        // 直接從 this.value 取值 (假設 table config 的 key 對應到 roles 陣列)
        if (Array.isArray(this.value) && this.value.length > 0) {
            return this.value;
        }
        // 如果沒有值或空陣列，回傳預設值
        return ["DEFAULT"];
    }

    // Helper: 取得單一角色的顯示文字
    public getRoleLabel(key: string): string {
        // 嘗試從全域 enums 中獲取翻譯 key
        const translationKey = (window as any).enums().EPlatformRole[key];

        // 如果有翻譯 key 就翻譯，否則直接顯示 key
        return translationKey ? this.$_(translationKey) : key;
    }

    // Helper: 取得單一角色的樣式 class
    public getBadgeClass(key: string): string {
        switch (key) {
            case "ADMIN":
                return "badge-admin";
            case "BILLING_ADMIN":
                return "badge-billing";
            case "USER":
                return "badge-user";
            default:
                return "badge-default";
        }
    }
}
